/** أنواع i18n المشتركة — ملف منفصل كي يستوردها detectLang بلا سحب React معه. */

/**
 * لغات الواجهة. العربية والإنجليزية مضمّنتان في الحزمة؛ البقية تُحمَّل عند اختيارها فقط
 * (import ديناميكي) فلا يدفع زائر عربي ثمن ١٢ قاموساً لن يراها.
 */
export const LANGS = [
    { code: 'ar', name: 'العربية', locale: 'ar' },
    { code: 'en', name: 'English', locale: 'en-US' },
    { code: 'es', name: 'Español', locale: 'es' },
    { code: 'fr', name: 'Français', locale: 'fr' },
    { code: 'de', name: 'Deutsch', locale: 'de' },
    { code: 'pt', name: 'Português', locale: 'pt-BR' },
    { code: 'it', name: 'Italiano', locale: 'it' },
    { code: 'ru', name: 'Русский', locale: 'ru' },
    { code: 'uk', name: 'Українська', locale: 'uk' },
    { code: 'tr', name: 'Türkçe', locale: 'tr' },
    { code: 'zh', name: '中文', locale: 'zh-CN' },
    { code: 'ja', name: '日本語', locale: 'ja' },
    { code: 'hi', name: 'हिन्दी', locale: 'hi' },
    { code: 'id', name: 'Bahasa Indonesia', locale: 'id' },
] as const;

export type Lang = (typeof LANGS)[number]['code'];

const CODES = new Set<string>(LANGS.map((l) => l.code));

export function isLang(value: unknown): value is Lang {
    return typeof value === 'string' && CODES.has(value);
}

/** وسم BCP-47 لواجهات Intl (تنسيق التواريخ والأرقام). */
export function langLocale(lang: Lang): string {
    return LANGS.find((l) => l.code === lang)?.locale ?? 'en-US';
}
